<script setup lang="ts">
import { Button, CellGroup, Field, Form, showFailToast } from 'vant';
import { ref } from 'vue';
import axios from 'axios';
import MD5 from 'crypto-js/md5';
import { useRouter } from 'vue-router';

const userId = ref('');
const password = ref('');

interface Response {
  email: string;
  enterprise_id: string;
  msg: string;
  name: string;
  outid: null;
  product_type: number;
  state: 0 | 1;
  user: string;
}

const router = useRouter();

const onSubmit = async () => {
  const resp = await axios.post<Response>('https://getuserinfoall-userserver-gggnycawlv.cn-hangzhou.fcapp.run', {
    'userId': userId.value,
    'pwdMD5': MD5(password.value).toString().toUpperCase(),
    'srcType': 'qingflow'
  });

  if (resp.data.state === 0) {
    showFailToast(resp.data.msg);
    return;
  }

  if (!resp.data.enterprise_id) {
    showFailToast(`${resp.data.user} enterprise_id 为空`);
    return;
  }

  localStorage.setItem('user', JSON.stringify({ ...resp.data }));

  await router.replace({
    name: 'admin-tryon'
  });
};

const onBack = async () => {
  router.back();
};
</script>

<template>
  <div :class="$style.container">
    <Form @submit="onSubmit" :class="$style.form">
      <CellGroup inset>
        <Field
          v-model="userId"
          :name="$t('tryon.user-id')"
          :label="$t('tryon.user-id')"
          :placeholder="$t('tryon.user-id')"
          :rules="[{ required: true, message: $t('tryon.message.enter-user-id') }]"
        />
        <Field
          v-model="password"
          type="password"
          :name="$t('tryon.password')"
          :label="$t('tryon.password')"
          :placeholder="$t('tryon.password')"
          :rules="[{ required: true, message: $t('tryon.message.enter-password') }]"
        />
      </CellGroup>

      <div style="padding-top: 30px; width: 100%; display: flex; gap: 16px;">
        <Button block @click="onBack">
          {{ $t('tryon.return') }}
        </Button>
        <Button block type="primary" native-type="submit">
          {{ $t('tryon.enter') }}
        </Button>
      </div>
    </Form>

  </div>
</template>

<style module>
.container {
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
}

.form {
  width: 100%;
  padding: 10px;
}

</style>
